import Navigation from "@/components/Navigation";
import Footer from "@/components/Footer";
import CompanyStory from "@/components/CompanyStory";
import Leadership from "@/components/Leadership";
import Partnerships from "@/components/Partnerships";
import SEOHead from "@/components/SEOHead";
import SkipLink from "@/components/SkipLink";
import { useSEO } from "@/hooks/useSEO";

const About = () => {
  useSEO({
    title: "About Smartborn - Our Journey, Leadership & Values | 8+ Years Excellence",
    description: "Learn about Smartborn's journey from startup to global technology partner. Meet our leadership team, discover our values, and explore our partnerships across 25+ industries.",
    keywords: "about smartborn, company story, leadership team, company values, technology partnerships, ISO 27001 certified, global IT company",
    canonical: "https://smartborn.io/about",
    ogType: "website"
  });

  return (
    <>
      <div className="min-h-screen">
        <SEOHead />
        <SkipLink />
        <Navigation />
        <main id="main-content" tabIndex={-1}>
          <CompanyStory />
          <Leadership />
          <Partnerships />
        </main>
        <Footer />
      </div>
    </>
  );
};

export default About;
